<template>
  <div class="product_qty_box">
    <label class="secondary_title">{{ $t("detail.quantity") }}</label>
    <div class="product_qty secondary_title">
      <v-inputnum
        type="productDetail"
        :productId="product_res.ID"
        v-model="add_cart_data.quantity"
        :theme="theme"
        @keyup.enter.native="!disabled && stock && add_cart()"
        :min="1"
      ></v-inputnum>
    </div>
  </div>
</template>
<script>
import vInputnum from "@/views/venue/js/common/inputnum.vue";
export default {
  components:{
    vInputnum
  },
  props: ["product_res", "add_cart_data", "disabled", "stock", "add_cart","theme"],
  data() {
    return {};
  },
};
</script>
<style scoped lang='scss'>
.product_qty_box {
  label {
    line-height: 42px;
    font-size: 15px;
    font-weight: bold;
  }
  .product_qty {
    float: right;
    button {
      background: rgba(255, 255, 255, 0.8);
      padding: 0;
      height: 36px;
      width: 36px;
      line-height: 34px;
      border: 1px solid rgba(17, 17, 17, 0.2);
      float: left;
    }
    input {
      font-size: 13px;
      color: #555;
      background: #f5f5f5;
      height: 36px;
      width: 36px;
      line-height: 34px;
      text-align: center;
      border: 1px solid rgba(17, 17, 17, 0.2);
      margin: 0 -1px;
      cursor: pointer;
      float: left;
      &::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
        margin: 0;
        -moz-appearance: textfield;
      }
    }
  }
}
</style>